export const getApiUrl = () => {
  const regex = /(https:\/\/)lk./
  if (window.location.origin.indexOf("localhost") > -1 || window.location.origin.indexOf("preprod") > -1) {
    return process.env.REACT_APP_PUBLIC_DEV_API_URL
  } else {
    return window.location.origin.replace(regex, "$1") + process.env.REACT_APP_PUBLIC_API_SUFFIX
  }
}
